import { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { LayoutErrorFallback } from '../../components/ErrorFallback/LayoutErrorFallback';
import { useLogger } from '../../context/useLogger';
import { logError } from '../../utils/logHelper';

// Niveau 2 : zone publique (login, callback, key-auth) — pas de queryClient à invalider
export function PublicErrorBoundary({
  children,
  errorLayout,
}: Readonly<{ children: React.ReactNode; errorLayout: string }>) {
  const logger = useLogger();

  return (
    <ErrorBoundary
      FallbackComponent={LayoutErrorFallback}
      onError={(error: unknown, info: ErrorInfo) => {
        const fallBackError =
          error instanceof Error ? error : new Error(`Unknown error on ${errorLayout}`);
        logError(logger, fallBackError, info);
      }}
      onReset={() => {
        logger.info(`ErrorBoundary reset - ${errorLayout}`);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
